import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-449ab20d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-col gap-4 md:gap-4 h-full min-h-0" }
const _hoisted_2 = { class: "hidden md:flex flex-row justify-between gap-2" }
const _hoisted_3 = {
  ref: "exportMenuContainerDesktop",
  class: "relative flex flex-row gap-4"
}
const _hoisted_4 = {
  key: 2,
  class: "absolute right-0 top-full mt-2 w-[320px] origin-top-right rounded-md bg-white shadow-lg focus:outline-none z-30 border border-gray-200"
}
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar relatório de apontamentos", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar escala em .pdf", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar relatório de vagas", -1))
const _hoisted_9 = { class: "md:hidden" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = {
  ref: "exportMenuContainerMobile",
  class: "relative"
}
const _hoisted_12 = {
  key: 1,
  class: "absolute right-0 top-full mt-2 w-[280px] origin-top-right rounded-md bg-white shadow-lg focus:outline-none z-30 border border-gray-200"
}
const _hoisted_13 = { class: "py-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar apontamentos", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar escala em .pdf", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar relatório de vagas", -1))
const _hoisted_17 = {
  key: 0,
  class: "relative mt-2"
}
const _hoisted_18 = { class: "flex items-center w-full bg-white p-1 rounded-lg border h-[40px]" }
const _hoisted_19 = { class: "relative w-full h-full flex items-center" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "text-red-500 text-[10px] font-medium animate-pulse px-1 absolute top-full left-0"
}
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "hidden md:flex flex-row items-center gap-2 w-full" }
const _hoisted_25 = { class: "flex-grow w-full md:w-auto" }
const _hoisted_26 = {
  key: 0,
  class: "relative shrink-0"
}
const _hoisted_27 = { class: "flex items-center w-[220px] bg-white p-1 rounded-lg border h-[40px]" }
const _hoisted_28 = { class: "relative w-full h-full flex items-center" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "text-red-500 text-[10px] font-medium animate-pulse px-1 absolute top-full left-0 whitespace-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_legends_group = _resolveComponent("legends-group")!
  const _component_filled_button = _resolveComponent("filled-button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_excelIcon = _resolveComponent("excelIcon")!
  const _component_pdfIcon = _resolveComponent("pdfIcon")!
  const _component_filters = _resolveComponent("filters")!
  const _component_DashboardSkeleton = _resolveComponent("DashboardSkeleton")!
  const _component_ReportErrorState = _resolveComponent("ReportErrorState")!
  const _component_DashboardView = _resolveComponent("DashboardView")!
  const _component_update_station_modal = _resolveComponent("update-station-modal")!
  const _component_create_station_modal = _resolveComponent("create-station-modal")!
  const _component_export_excel_modal = _resolveComponent("export-excel-modal")!
  const _component_export_stations_excel_modal = _resolveComponent("export-stations-excel-modal")!
  const _component_export_stations_modal = _resolveComponent("export-stations-modal")!
  const _component_station_details_modal = _resolveComponent("station-details-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_legends_group),
        _createElementVNode("div", _hoisted_3, [
          ($setup.canCreateStation)
            ? (_openBlock(), _createBlock(_component_filled_button, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCreateStationModal = true)),
                text: "Criar plantão",
                class: "bg-primary30",
                width: "150px",
                height: "48px"
              }))
            : _createCommentVNode("", true),
          ($setup.canStationDoctorCheckXlsReportExporting)
            ? (_openBlock(), _createBlock(_component_outline_button, {
                key: 1,
                onClick: $setup.toggleExportMenu,
                density: "compact",
                width: "120px",
                height: "48px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: $setup.mdiChevronDown,
                    size: 24,
                    class: "cursor-pointer"
                  }, null, 8, ["icon"]),
                  _createTextVNode("Exportar ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          ($setup.showExportMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  ($setup.canStationDoctorCheckXlsReportExporting)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white border-b border-gray-200",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.downloadExcel && $setup.downloadExcel(...args)))
                      }, [
                        _createVNode(_component_excelIcon, {
                          width: "20",
                          height: "20",
                          color: "currentColor"
                        }),
                        _hoisted_6
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.canStationPdfReportExporting)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white border-b border-gray-200",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.downloadSchedules && $setup.downloadSchedules(...args)))
                      }, [
                        _createVNode(_component_pdfIcon, {
                          width: "20",
                          height: "20",
                          color: "currentColor"
                        }),
                        _hoisted_7
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.canStationXlsReportExporting)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.downloadStationsExcel && $setup.downloadStationsExcel(...args)))
                      }, [
                        _createVNode(_component_excelIcon, {
                          width: "20",
                          height: "20",
                          color: "currentColor"
                        }),
                        _hoisted_8
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          ($setup.canCreateStation)
            ? (_openBlock(), _createBlock(_component_filled_button, {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showCreateStationModal = true)),
                text: "+ Plantão",
                class: "bg-primary30",
                width: "auto",
                height: "36px"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            ($setup.canStationDoctorCheckXlsReportExporting)
              ? (_openBlock(), _createBlock(_component_outline_button, {
                  key: 0,
                  onClick: $setup.toggleExportMenu,
                  density: "compact",
                  width: "auto",
                  height: "36px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: $setup.mdiChevronDown,
                      size: 18,
                      class: "cursor-pointer"
                    }, null, 8, ["icon"]),
                    _createTextVNode("Exportar ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($setup.showExportMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    ($setup.canStationDoctorCheckXlsReportExporting)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white border-b border-gray-200",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.downloadExcel && $setup.downloadExcel(...args)))
                        }, [
                          _createVNode(_component_excelIcon, {
                            width: "20",
                            height: "20",
                            color: "currentColor"
                          }),
                          _hoisted_14
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.canStationPdfReportExporting)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white border-b border-gray-200",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.downloadSchedules && $setup.downloadSchedules(...args)))
                        }, [
                          _createVNode(_component_pdfIcon, {
                            width: "20",
                            height: "20",
                            color: "currentColor"
                          }),
                          _hoisted_15
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.canStationXlsReportExporting)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          class: "flex cursor-pointer items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-primary20 hover:text-white",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.downloadStationsExcel && $setup.downloadStationsExcel(...args)))
                        }, [
                          _createVNode(_component_excelIcon, {
                            width: "20",
                            height: "20",
                            color: "currentColor"
                          }),
                          _hoisted_16
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showMobileFilters = !$setup.showMobileFilters)),
            class: "flex items-center gap-1 px-3 h-[36px] border border-gray-300 rounded-full text-gray-500 text-sm"
          }, [
            _createVNode(_component_v_icon, {
              icon: $setup.mdiFilterVariant,
              size: 18
            }, null, 8, ["icon"]),
            _createTextVNode(" Filtros "),
            _createVNode(_component_v_icon, {
              icon: $setup.showMobileFilters ? $setup.mdiChevronUp : $setup.mdiChevronDown,
              size: 16
            }, null, 8, ["icon"])
          ])
        ]),
        ($setup.isSearchByIdEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.searchId) = $event)),
                    onKeyup: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => ($setup.handleSearchById && $setup.handleSearchById(...args)), ["enter"])),
                    type: "number",
                    placeholder: "Buscar ID...",
                    disabled: $setup.isSearching,
                    class: "w-full pl-2 pr-8 py-0 bg-transparent focus:outline-none text-sm border-none ring-0 h-full appearance-none"
                  }, null, 40, _hoisted_20), [
                    [_vModelText, $setup.searchId]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.handleSearchById && $setup.handleSearchById(...args))),
                    disabled: $setup.isSearching,
                    class: "absolute right-0 top-0 bottom-0 px-2 text-gray-400 hover:text-primary transition-colors disabled:cursor-not-allowed flex items-center justify-center"
                  }, [
                    (!$setup.isSearching)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          icon: $setup.mdiMagnify,
                          size: "20",
                          class: "text-gray-400"
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          icon: $setup.mdiSync,
                          size: "20",
                          class: "animate-spin text-primary"
                        }, null, 8, ["icon"]))
                  ], 8, _hoisted_21)
                ])
              ]),
              ($setup.searchError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString($setup.searchError), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_23, [
          _createVNode(_component_filters)
        ], 512), [
          [_vShow, $setup.showMobileFilters]
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_filters)
        ]),
        ($setup.isSearchByIdEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.searchId) = $event)),
                    onKeyup: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => ($setup.handleSearchById && $setup.handleSearchById(...args)), ["enter"])),
                    type: "number",
                    placeholder: "Buscar ID...",
                    disabled: $setup.isSearching,
                    class: "w-full pl-2 pr-8 py-0 bg-transparent focus:outline-none text-sm border-none ring-0 h-full appearance-none"
                  }, null, 40, _hoisted_29), [
                    [_vModelText, $setup.searchId]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.handleSearchById && $setup.handleSearchById(...args))),
                    disabled: $setup.isSearching,
                    class: "absolute right-0 top-0 bottom-0 px-2 text-gray-400 hover:text-primary transition-colors disabled:cursor-not-allowed flex items-center justify-center"
                  }, [
                    (!$setup.isSearching)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          icon: $setup.mdiMagnify,
                          size: "20",
                          class: "text-gray-400"
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          icon: $setup.mdiLoading,
                          size: "20",
                          class: "animate-spin text-primary"
                        }, null, 8, ["icon"]))
                  ], 8, _hoisted_30)
                ])
              ]),
              ($setup.searchError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.searchError), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      ($setup.isLoadingListStations)
        ? (_openBlock(), _createBlock(_component_DashboardSkeleton, { key: 0 }))
        : ($setup.loadError)
          ? (_openBlock(), _createBlock(_component_ReportErrorState, {
              key: 1,
              title: "Não foi possível carregar os plantões",
              message: $setup.loadErrorDetail,
              onRetry: $setup.retryLoadStations
            }, null, 8, ["message", "onRetry"]))
          : (_openBlock(), _createBlock(_component_DashboardView, {
              key: 2,
              id: "dashboard",
              weekData: $setup.listStations,
              "week-table-head": $setup.listStations?.tableHead || [],
              selectedYearDay: $setup.selectedYearDay,
              onOpenDutyModal: $setup.handleOpenDetailsModal,
              onUpdateDate: $setup.handleUpdateDate
            }, null, 8, ["weekData", "week-table-head", "selectedYearDay", "onOpenDutyModal", "onUpdateDate"]))
    ]),
    ($setup.stationSelected && $setup.showEditDutyModal)
      ? (_openBlock(), _createBlock(_component_update_station_modal, {
          key: 0,
          infos: $setup.stationSelected,
          "exception-status": $setup.stationSelected.exceptionStatus,
          "show-modal": $setup.showEditDutyModal,
          onCloseModal: $setup.handleEditSaved,
          onGoBack: $setup.handleGoBack,
          onSaved: $setup.handleGoBack
        }, null, 8, ["infos", "exception-status", "show-modal", "onCloseModal", "onGoBack", "onSaved"]))
      : _createCommentVNode("", true),
    _createVNode(_component_create_station_modal, {
      showModal: $setup.showCreateStationModal,
      onCloseModal: _cache[15] || (_cache[15] = ($event: any) => ($setup.showCreateStationModal = false))
    }, null, 8, ["showModal"]),
    _createVNode(_component_export_excel_modal),
    _createVNode(_component_export_stations_excel_modal),
    _createVNode(_component_export_stations_modal),
    ($setup.stationSelected)
      ? (_openBlock(), _createBlock(_component_station_details_modal, {
          key: 1,
          infos: $setup.stationSelected,
          showModal: $setup.showDetailsModal,
          "exception-id-selected": $setup.pendingExceptionId,
          "onUpdate:showModal": _cache[16] || (_cache[16] = ($event: any) => ($setup.showDetailsModal = $event)),
          onCloseModal: $setup.handleShowDetailsModal,
          onEditStation: $setup.handleEditStation,
          onNavigateToStation: $setup.handleNavigateToStation
        }, null, 8, ["infos", "showModal", "exception-id-selected", "onCloseModal", "onEditStation", "onNavigateToStation"]))
      : _createCommentVNode("", true)
  ], 64))
}